import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { ClearHistoryIcon } from '$common/icons/clear-history'
import { RemoveChatIcon } from '$common/icons/remove-chat'
import { t } from '$i18n'
import {
  showClearWappRoomHistory,
  showDeleteWappRoomModal,
} from '$comp/modals/confirmation-dialog'

interface Props {
  wappId: string
  isOpen: boolean
}

export function WappProfileMenu({ wappId, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.removeChat')}
        onClick={async () => {
          await closeCurrentModal()
          showDeleteWappRoomModal(wappId)
        }}
      >
        <RemoveChatIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.common.clearHistory')}
        onClick={async () => {
          await closeCurrentModal()
          showClearWappRoomHistory(wappId)
        }}
      >
        <ClearHistoryIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
